<template>
    <v-container>
        <v-card class="card-style">
            <v-card-title primary-title class="display-3 text">
              EG&nbsp;Pilots
            </v-card-title>
            <v-card-text>
                <p class="lead text"> - игровое сообщество, объединившее любителей игр о космосе. </p>
                <span class="lead text">Все, кто грезит о бескрайних пространствах и далеких звездах, исследовании новых планет и космических битвах, найдут в нас единомышленников и друзей. Удобная система общения на серверах Discord, помощь новичкам, игровые ивенты и многое другое, сделают любую игру еще интереснее. Присоединяйся!</span><!-- розыгрыши призов -->
            </v-card-text>
        </v-card>
    </v-container>
</template>

<script>
    export default {}
</script>

<style scoped>
    .text {
        color: #fff;
        font-family: "EnigmaticUnicodeRegular" !important;
    }
</style>